import { Injectable } from "@angular/core";
import { AuditEmailsAPIConstant } from "../constant/emails-audit.constant";
import { RestService } from "../../../core/service/rest.service";

@Injectable({
    providedIn: 'root'
})
export class EmailsAuditService {
    constructor(private rest: RestService) { }
    GetAuditEmails(payload: any) { return this.rest.post(AuditEmailsAPIConstant.GET_AUDIT_EMAILS, payload) }
    GetAuditEmailUsers(payload: any) { return this.rest.get(AuditEmailsAPIConstant.GET_AUDIT_EMAIL_USERS, payload) }
    GetMaterialName(payload: any) { return this.rest.get(AuditEmailsAPIConstant.GET_MATERIA_NAME, payload) }
    GetAuditEmailsForExcel(payload: any) { return this.rest.downloadPost(AuditEmailsAPIConstant.GET_AUDIT_EMAILS_FOR_EXCEL, payload) }

}